<template>
  <v-row justify="center">
    <v-dialog v-model="active" max-width="400">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          場次密碼
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:40px; font-size:15px">
          本場次報名密碼，請告知報名學員 :  
        </v-card-text>
        <v-text-field class="mx-14 mb-2 pt14" dense background-color="white" outlined readonly style="border-radius:10px">
          <!-- 顯示場次密碼 -->
        </v-text-field>
        <v-row justify="center">
          <v-col cols="2">
          </v-col>
          <v-col cols="6">
            <v-btn outlined color="#FFF" style="width:200px; height:46px; border-radius:10px; background:#81C0E2">
              場次密碼複製
            </v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn outlined color="#FFF" style="width:100%; height:46px; border-radius:10px; background:#215DA7">
              已複製
            </v-btn>
            <!-- 顯示三秒，可以用透明度0-100秒數去設 -->
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'ProjectPassword',
    data () {
      return {
        active: false,
      }
    },
    methods:{
      open(data){
        this.active = true
        this.sendType = data
      },
      close(){
        this.active = false
      },
      save(){
        this.close()
      }
    }
  }
</script>